export default {
  data() {
    return {}
  },
  methods: {
    transKeyToLabel(key) {
      switch (key) {
        case 'currentAssets':
          return '流动资产合计(Total Current Assets)'
        case 'monetaryFund':
          return '货币资金(Cash at Bank & in Hand)'
        case 'transactionalFinancialAssets':
          return '交易性金融资产(Financial Assets Held for Trading)'
        case 'notesReceivable':
          return '应收票据(Notes Receivable)'
        case 'accountsReceivable':
          return '应收账款(Accounts Receivable)'
        case 'otherReceivables':
          return '其他应收款(Other Receivables)'
        case 'advancePayment':
          return '预付账款(Advances to Suppliers)'
        case 'inventory':
          return '存货(Inventories)'
        case 'nonCurrentAssetsDueWithinOneYear':
          return '一年内到期的非流动资产(Non-current Assets Due within One Year)'
        case 'otherCurrentAssets':
          return '其他流动资产(Other Current Assets)'
        case 'totalNonCurrentAssets':
          return '非流动资产合计(Total Non-current Assets)'
        case 'totalFixedAssets':
          return '固定资产合计(Total Fixed Assets)'
        case 'originalValueOfFixedAssets':
          return '固定资产原值(Fixed Assets - Cost)'
        case 'accumulatedDepreciation':
          return '累计折旧(Accumulated Depreciation)'
        case 'netFixedAssets':
          return '固定资产净值(Fixed Assets - Net Value)'
        case 'projectsUnderConstruction':
          return '在建工程(Construction in Progress)'
        case 'longTermInvestment':
          return '长期投资(Long-term Investment)'
        case 'intangibleAssets':
          return '无形资产(Intangible Assets)'
        case 'deferredAssets':
          return '递延资产(Deferred Assets)'
        case 'longTermDeferredExpenses':
          return '长期待摊费用(Long-term Prepaid Expenses)'
        case 'otherNonCurrentAssets':
          return '其他非流动资产(Other Non-current Assets)'
        case 'totalAssets':
          return '资产总计(Total Assets)'
        // nonCurrentAssetKeys
        case 'totalCurrentLiabilities':
          return '流动负债合计(Total Current Liabilities)'
        case 'shortTermBorrowing':
          return '短期借款(Short-term Borrowings)'
        case 'notesPayable':
          return '应付票据(Notes Payable)'
        case 'accountsPayable':
          return '应付账款(Accounts Payable)'
        case 'otherPayables':
          return '其他应付款(Other Payables)'
        case 'advancesFromCustomers':
          return '预收账款(Advances from Customers)'
        case 'payPayable':
          return '应付职工薪酬(Employee Benefits Payable)'
        case 'taxesPayable':
          return '应付税金(Taxes Payable)'
        case 'nonCurrentLiabilitiesDueWithinOneYear':
          return '一年内到期的非流动负债(Non-current Liabilities Due within One Year)'
        case 'otherCurrentLiabilities':
          return '其他流动负债(Other Current Liabilities)'
        case 'totalNonCurrentLiabilities':
          return '非流动负债合计(Total Non-current Liabilities)'
        case 'longTermBorrowing':
          return '长期借款(Long-term Borrowings)'
        case 'longTermPayables':
          return '长期应付款(Long-term Payables)'
        case 'bondsPayable':
          return '应付债券(Bonds)'
        case 'otherNonCurrentLiabilities':
          return '其他非流动负债(Other Non-current Liabilities)'
        case 'totalLiabilities':
          return '负债合计(Total Liabilities)'
        case 'paidInCapital':
          return '实收资本(Paid-in Capital)'
        case 'capitalReserves':
          return '资本公积(Capital Reserves)'
        case 'surplusReserves':
          return '盈余公积(Surplus Reserves)'
        case 'undistributedProfit':
          return '未分配利润(Undistributed Profit)'
        case 'totalShareholderEquity':
          return '股东权益合计(Total Shareholders`Equity)'
        case 'totalLiabilitiesAndShareholdersEquity':
          return '负债及股东权益合计(Total Liabilities and Shareholders`Equity)'
        // currentLiabilityKeys
        case 'revenueFromMainOperations':
          return '主营业务收入(Revenues from Main Operations)'
        case 'minusMainBusinessCost':
          return '减:主营业务成本(Less: Cost of Main Operations)'
        case 'mainBusinessTaxesAndAdditionalTaxes':
          return '主营业务税金及附加(Taxes and Surcharge for Main Operations)'
        case 'mainBusinessProfit':
          return '主营业务利润(Profits from Main Operations)'
        case 'costOfSales':
          return '销售费用(Selling Expenses)'
        case 'managementFees':
          return '管理费用(General and Administrative Expenses)'
        case 'financeCharges':
          return '财务费用(Financial Expenses)'
        case 'otherFees':
          return '其他费用(Other Expenses)'
        case 'plusReturnOnInvestment':
          return '加:投资收益(Add: Investment Income)'
        case 'otherBusinessProfits':
          return '其他业务利润(Profits from Other Operations)'
        case 'operatingProfit':
          return '营业利润(Operating Profits)'
        case 'nonOperatingIncome':
          return '营业外收入(Non-operating Income)'
        case 'nonOperatingExpenses':
          return '营业外支出(Non-operating Expenses)'
        case 'plusPriorYearProfitAndLossAdjustment':
          return '加：以前年度损益调整(Add: Adjustment to Prior Years`Income and Losses)'
        case 'profitTotal':
          return '利润总额(Total Profits)'
        case 'lessIncomeTax':
          return '减:所得税(Less: Income Tax)'
        case 'netProfit':
          return '净利润(Net Profits)'
      }
    },
  },
}
